import { CircularProgress } from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";

const SectionCard = (props) => {
  const { data, link } = props;
  const [imgLoaded, setimgLoaded] = useState(false);
  return (
    <Link to={link} className="section-card">
      <div className="img" style={{ backgroundColor: imgLoaded ? "transparent" : "var(--color-grey-opaque)" }}>
        {!imgLoaded && (
          <div className="spinner-container">
            <CircularProgress className="spinner" size="3rem" />
          </div>
        )}
        <img src={data.img} alt={data.name} onLoad={() => setimgLoaded(true)} />
      </div>
      <p>{data.name}</p>
    </Link>
  );
};

export default SectionCard;
